


import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function SOCIOECONOMIC_IMPACT() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
  <iframe
    src={t('SOCIOECONOMIC_IMPACT')}
    title="PDF Document"
  />
</div>

  );
};

export default SOCIOECONOMIC_IMPACT;
